import { createContext, useContext } from 'react';

import type { Alapadatok } from './api.ts';

/**
 * A választéklisták (fizetési módok, kategóriák, beállítások) egyszer töltődnek
 * be induláskor, és innen éri el őket minden képernyő. Így nem kell minden
 * legördülő listához külön kérést indítani.
 */
export const AlapadatokContext = createContext<Alapadatok | null>(null);

export function useAlapadatok(): Alapadatok {
  const a = useContext(AlapadatokContext);
  if (!a) throw new Error('Az alapadatok még nem töltődtek be.');
  return a;
}
